import type { IReportStoragePort } from '@reports/application/ports';

/**
 * Use case to clear filters metadata from storage
 *
 * @param storagePort - Storage port implementation
 * @returns Use case with execute method
 */
export const clearFiltersMetadataUseCase = (storagePort: IReportStoragePort) => {
  const execute = async (): Promise<void> => {
    await storagePort.clearFiltersMetadata();
  };

  return { execute };
};
